import {PropsWithChildren} from "react";
import {motion} from "framer-motion";

import {getHomematchTinderDeckHeightMotionTransition} from "../../constants/homematch_tinder_motion";
import {getTinderDeckBackingPaddingTop} from "../../utils/tinder_deck_utils";
import {HomematchTinderDeckShadows} from "../HomematchTinderDeckShadows";

import * as styles from "./HomematchTinderDeck.module.css";

interface IProps extends PropsWithChildren {
    frozenHeight: number | null;
    isAdvancing: boolean;
    setDeckNode: (node: HTMLDivElement | null) => void;
    shadowKeys: number[];
    shouldReduceMotion: boolean;
    showDeckShadows: boolean;
}

export const HomematchTinderDeck = (props: IProps) => {
    const {children, frozenHeight, isAdvancing, setDeckNode, shadowKeys, shouldReduceMotion, showDeckShadows} = props;

    const deckMotionTransition = getHomematchTinderDeckHeightMotionTransition({isAdvancing, shouldReduceMotion});

    return (
        <motion.div
            animate={{
                minHeight: isAdvancing && frozenHeight ? frozenHeight : undefined,
                paddingTop: getTinderDeckBackingPaddingTop(shadowKeys.length)
            }}
            className={styles.stack}
            ref={setDeckNode}
            transition={deckMotionTransition}
        >
            {showDeckShadows && <HomematchTinderDeckShadows reduceMotion={shouldReduceMotion} shadowKeys={shadowKeys} />}

            {children}
        </motion.div>
    );
};
import {PropsWithChildren} from "react";
import {motion} from "framer-motion";

import {getHomematchTinderDeckHeightMotionTransition} from "../../constants/homematch_tinder_motion";
import {getTinderDeckBackingPaddingTop} from "../../utils/tinder_deck_utils";
import {HomematchTinderDeckShadows} from "../HomematchTinderDeckShadows";

import * as styles from "./HomematchTinderDeck.module.css";

interface IProps extends PropsWithChildren {
    frozenHeight: number | null;
    isAdvancing: boolean;
    setDeckNode: (node: HTMLDivElement | null) => void;
    shadowKeys: number[];
    shouldReduceMotion: boolean;
    showDeckShadows: boolean;
}

export const HomematchTinderDeck = (props: IProps) => {
    const {children, frozenHeight, isAdvancing, setDeckNode, shadowKeys, shouldReduceMotion, showDeckShadows} = props;

    const deckMotionTransition = getHomematchTinderDeckHeightMotionTransition({isAdvancing, shouldReduceMotion});

    return (
        <motion.div
            animate={{
                minHeight: isAdvancing && frozenHeight ? frozenHeight : undefined,
                paddingTop: getTinderDeckBackingPaddingTop(shadowKeys.length)
            }}
            className={styles.stack}
            ref={setDeckNode}
            transition={deckMotionTransition}
        >
            {showDeckShadows && <HomematchTinderDeckShadows reduceMotion={shouldReduceMotion} shadowKeys={shadowKeys} />}

            {children}
        </motion.div>
    );
};
